function AnnouncementService() {
    this.constructor.apply(this, arguments);
}

AnnouncementService.$inject = ['$q', '$http', '$Config', '$state'];
AnnouncementService.prototype = {
    /**
     *
     * @param $q {angular.IQService}
     * @param $http {angular.IHttpService}
     * @param $Config {Config}
     * @param $state {$state}
     */
    constructor($q, $http, $Config, $state) {
        this.$q = $q;
        this.$http = $http;
        this.$Config = $Config;
        this.$state = $state;



        /** @type IAnnouncement */
        this.announcementDetails = null;
    },

    /**
     * Helper function to construct the full API URL by appending the provided endpoint to the base URL
     * @param url {string} - The endpoint to append to the base API URL
     * @returns {string} - The full API URL
     */
    getUrl(url) {
        return this.$Config.apiUrl + url;
    },


    /**
     *
     * @returns {angular.IPromise<IAnnouncement[]>}
     */
    getActiveAnnouncements() {
        return this.$q(angular.bind(this, function (resolve, reject) {
            this.$http.get(this.getUrl('mobile/Announcement/GetActiveAnnouncements')).then(function (response) {
                resolve(response.data); // Resolve the promise with the response data
            }, reject); // Reject the promise if the HTTP request fails
        }));
    },

    /**
     *
     * @param item {IAnnouncement}
     * @param prevState {string=}
     * @returns {angular.IPromise<any>}
     */
    gotToDetails(item, prevState) {
        this.announcementDetails = item;
        return this.$state.go('internal.announcement-details', {
            prevState: prevState
        });
    }
}
angular.module('internal.announcements').service('AnnouncementService', AnnouncementService);